module.exports = __webpack_public_path__ + "media/images/news/200331-513d6569d63569fee71c3f467ec8b3f1.jpg";